<cyborg-section id="search-results">
  @if (searchStateService.resultsError | async) {
    <hyperkit-message class="error" type="error"></hyperkit-message>
  } @else {
    @if (searchStateService.resultsLoading | async) {
      <div class="loading">
        <kendo-loader type="pulsing" themeColor="primary" size="large">
        </kendo-loader>
      </div>
    } @else {
      @if (searchStateService.results | async; as results) {
        <div>
          <div class="results-header">
            <div class="result-logo">
              <hyperkit-typography variant="h5" align="left" color="primary">
                {{ results.data.total }} Result{{
                  results.data.total != 1 ? 's' : ''
                }}
              </hyperkit-typography>
            </div>
            <div class="toolbar">
              <cyborg-search-sort></cyborg-search-sort>
            </div>
          </div>
          <!-- Render appropriate sub-component based on result type-->
          @for (result of results.data.results; track result) {
            <div>
              @if (searchDataService.isHuntPack(result)) {
                <hunt-package [data]="result"></hunt-package>
              }
              @if (searchDataService.isThreatProfile(result)) {
                <threat-profiles [data]="result"> </threat-profiles>
              }
              @if (searchDataService.isCollection(result)) {
                <cyborg-collection [data]="result" [highlighting]="true">
                </cyborg-collection>
              }
            </div>
          }
          <kendo-datapager
            [style.width.%]="100"
            [pageSize]="pageSize"
            [skip]="skip"
            [total]="results.data.total"
            [pageSizeValues]="false"
            (pageChange)="onPageChange($event)"
          >
          </kendo-datapager>
        </div>
      }
    }
  }
</cyborg-section>
